import React from 'react';
import EditCrm from '../crm/EditCrm';
import DataTable from '../DataTable';
import SlidingSideBar from '../SlidingSideBar/SlidingSideBar';
import Tasks from '../tasks/Tasks';
import { getProfileFromLocalStorage } from '../../helpers/session';

const contactIgnoreFields = ['mostRecentComment', 'tasks'];

const ContactInfoSideBar = ({
  sidebarMode,
  onContactInfoSideBarHide,
  contact,
  appChoices,
  onContactEdit,
  onContactDelete,
  onAddInventoryPopupMetaChange,
  addInvenroryPopupMeta,
  onAddInvetoryPopupMetaClose
}) => {
  const currentUserId = getProfileFromLocalStorage()?._id;

  return (
    <SlidingSideBar
      fullScreen
      visible={sidebarMode !== null}
      onClose={onContactInfoSideBarHide}
      title={'Contact Details'}
    >
      {contact && sidebarMode !== null && (
        <>
          {sidebarMode === 'view' ? (
            <>
              <DataTable data={contact} ignoreFields={contactIgnoreFields} />
              <div className="mt-4">
                <Tasks
                  tasks={contact.tasks || []}
                  disabled={true}
                  appChoices={appChoices}
                  currentUserId={currentUserId}
                />
              </div>
            </>
          ) : (
            <EditCrm
              contactFromSearch={contact}
              appChoices={appChoices}
              fromSearch
              onContactDelete={onContactDelete}
              onContactEdit={onContactEdit}
              onAddInventoryPopupMetaChange={onAddInventoryPopupMetaChange}
              addInvenroryPopupMeta={addInvenroryPopupMeta}
              onAddInvetoryPopupMetaClose={onAddInvetoryPopupMetaClose}
            />
          )}
        </>
      )}
    </SlidingSideBar>
  );
};

export default ContactInfoSideBar;
